/* eslint-disable max-len */
/* eslint-disable prefer-const */
/* eslint-disable camelcase */
import isEmpty from 'lodash.isempty';
import qs from 'qs';
import {
 all, put, select, takeLatest,
} from 'redux-saga/effects';
import { removeEmptyEntries } from '../../../common/utils';
import toaster from '../../../components/atoms/toaster';
import API_ENDPOINTS from '../../../config/API-endpoints';
import { protectedRoutes } from '../../../routes';
import { getCookie } from '../../../utils';
import history from '../../history';
import { waitFor } from '../../utils';
import { fetcherAction } from '../fetcher/creator';
import { sessionActions } from '../session/creator';
import { searchActions, searchConstants } from './creator';
import * as searchSelectors from './selector';

const candidateSearchAPI = {
  search: (payload, params = {}) => ({
    tokenize: true,
    fetcherParams: {
      method: 'POST',
      url: API_ENDPOINTS.candidateSearch,
      data: {
 ...payload, from: 0, size: payload.size ?? 50, ...params,
},
    },
    headers: {
      Authorization: getCookie('authToken'),
      'Content-Type': 'application/json',
    },
  }),
};
const keysToCheckForEmptyArrays = [
  'nice_to_have_skills',
  'must_have_skills',
  'location',
  'specialization',
  'institute',
  'degree',
  'organization',
  'designation',
];

// eslint-disable-next-line require-yield
function* handleLocationChange({ payload }) {
  return payload;
}

function* searchCandidates({ payload }) {
  yield put(searchActions.setSearchResults({ loading: true }, { update: true }));
  let query = {
    experience_years_min: Number(payload.min_experience) || null,
    experience_years_max: Number(payload.max_experience) || null,
    last_contacted_on_min: Number(payload.last_contacted_on_min) || null,
    last_contacted_on_max: Number(payload.last_contacted_on_max) || null,

    designation: payload.designation,

    organization: payload.target_company,

    degree: payload.job_qualifications
      ?.reduce((arr, _) => [...arr, ...(_.degree || [])], []),
    institute: payload.job_qualifications
      ?.reduce((arr, _) => [...arr, ...(_.institute || [])], []),
    specialization: payload.job_qualifications
      ?.reduce((arr, _) => [...arr, ...(_.specialization || [])], []),

    location: payload.location,
    country: payload?.country_name,
    must_have_skills: payload.job_skills
      ?.filter((_) => _.priority).map((_) => _.skill.split(' or ')),
    nice_to_have_skills: payload.job_skills
      ?.filter((_) => !_.priority).map((_) => _.skill.split(' or ')),
    is_active_pipeline: 'All',
  };
  if (payload.dev_environment_exp) {
    query.must_have_skills.push([payload.dev_environment_exp]);
  }
  keysToCheckForEmptyArrays.forEach((key) => {
    if (isEmpty(query[key])) {
      delete query[key];
    }
  });

  query = removeEmptyEntries(query);

  const requestPayload = {
    query,
    jd_id: payload?.id || '-1',
    source: payload?.source?.value,
    sort_attrs: [{ ...payload?.sort_attrs?.value }],
    is_latest: false,
  };

  return yield put(fetcherAction({
    ...candidateSearchAPI.search(requestPayload),
    label: searchConstants.SEARCH_CANDIDATES,
  }));
}

function* searchCandidatesOnSuccess({ reqPayload, response }) {
  // uncomment this line to not allow to go to search results page
  // if (response.candidates.length === 0) {
  //   yield put(searchActions.setSearchResults({ loading: false }, { update: true }));
  //   return toaster({
  //     type: 'error',
  //     msg: `No Candidates Found`,
  //   });
  // }
  yield put(searchActions.setSearchResults(response));
  yield waitFor(searchSelectors.getSearchForm);
  const { title, job_code, searchConfigs } = yield select(searchSelectors.getSearchForm);
  const { data: beStructure } = reqPayload.fetcherParams;
  let { jd_id, sort_attrs, query } = beStructure;
  query = {
 ...query, job_code, title, searchConfigs,
};
  let searchParams = { jd_id, sort_attrs, query };

  // extracting additional data from the query params
  if (qs.parse(history.location.search)?.overview) {
    searchParams = { ...searchParams, overview: qs.parse(history.location.search)?.overview };
  }

  searchParams = removeEmptyEntries(searchParams);
  return yield history.push({
    pathname: protectedRoutes.searchResults,
    search: qs.stringify({ ...searchParams }),
  });
}

function* searchCandidatesOnFailure({ error }) {
  // logout if not not authorized
  if (error?.response?.status === 401) {
    return yield put(sessionActions.userLogout());
  }
  toaster({
    type: 'error',
    msg: 'Couldn\'t run the search at the moment, Please try again later',
  });
  yield put(searchActions.setSearchResults({ loading: false }, { update: true }));
  return error;
}

function* applyFilters({ payload }) {
  yield put(searchActions.setSearchResults({ loading: true }, { update: true }));
  const formPayload = yield select(searchSelectors.getSearchForm);
  keysToCheckForEmptyArrays.forEach((key) => {
    if (isEmpty(payload?.query[key])) {
      delete payload?.query[key];
    }
  });
  // remove all null and undefined value
  removeEmptyEntries(payload?.query);
  const requestPayload = {
    ...payload,
    jd_id: formPayload?.id || '-1',
  };
  return yield put(fetcherAction({
    ...candidateSearchAPI.search(requestPayload, {
      filterData: 1,
      sortData: 1,
    }),
    label: searchConstants.APPLY_FILTERS,
  }));
}

function* applyFiltersOnSuccess({ reqPayload, response }) {
  // eslint-disable-next-line no-unused-vars
  const { facets, ...rest } = response;
  yield put(searchActions.setSearchResults(response, { update: true }));
  // include required url params in the below location
  const { title } = yield select(searchSelectors.getSearchForm);
  // eslint-disable-next-line no-unsafe-optional-chaining
  const { jd_id, sort_attrs, query } = reqPayload?.fetcherParams?.data;
  query.title = title;
  let searchParams = {
 jd_id, sort_attrs, query, title,
};

  // extracting additional data from the query params
  if (qs.parse(history.location.search)?.overview) {
    searchParams = { ...searchParams, overview: qs.parse(history.location.search)?.overview };
  }

  searchParams = removeEmptyEntries(searchParams);
  // todo: check exp_range values
  return yield history.push({
    pathname: protectedRoutes.searchResults,
    search: qs.stringify({ ...searchParams }),
  });
}

function* applyFiltersOnFailure({ }) {
  toaster({
    type: 'error',
    msg: 'Couldn\'t apply the filters at the moment, Please try again later',
  });
  return yield put(searchActions.setSearchResults({ loading: false }, { update: true }));
}

function* loadMoreCandidates({ payload }) {
  const loadingMore = yield select(searchSelectors.getLoadingBool);
  const {
     totalCount,
  } = yield select(searchSelectors.getResultsMeta);
  const candidates = yield select(searchSelectors.getCandidates);
  if (loadingMore || candidates.length >= totalCount) { return true; }
  yield put(searchActions.setSearchResults({ loading: true }, { update: true }));
  const reqPayload = yield select(searchSelectors.getSearchForm);

  keysToCheckForEmptyArrays.forEach((key) => {
    if (isEmpty(payload?.query[key])) {
      delete payload?.query[key];
    }
  });
  const requestPayload = {
    ...payload, jd_id: reqPayload?.id || '-1',
  };
  return yield put(fetcherAction({
    ...candidateSearchAPI.search(
requestPayload,
      {
        from: payload?.from || 0,
        filterData: 1,
        sortData: 1,
        size: payload?.size || 50,
      },
),
    label: searchConstants.LOAD_MORE_CANDIDATES,
  }));
}

function* loadMoreCandidatesOnSuccess({ response }) {
  return yield put(searchActions.appendCandidates(response));
}

function* loadMoreCandidatesOnFailure({ }) {
  toaster({
    type: 'error',
    msg: 'Couldn\'t load more results at the moment, Please try again later',
  });

  return yield put(searchActions.setSearchResults({ loading: false }, { update: true }));
}

export default function* searchSagas() {
  yield all([
    takeLatest(searchConstants.SEARCH_CANDIDATES.TRIGGER, searchCandidates),
    takeLatest(searchConstants.SEARCH_CANDIDATES.SUCCESS, searchCandidatesOnSuccess),
    takeLatest(searchConstants.SEARCH_CANDIDATES.FAILURE, searchCandidatesOnFailure),

    takeLatest(searchConstants.LOAD_MORE_CANDIDATES.TRIGGER, loadMoreCandidates),
    takeLatest(searchConstants.LOAD_MORE_CANDIDATES.SUCCESS, loadMoreCandidatesOnSuccess),
    takeLatest(searchConstants.LOAD_MORE_CANDIDATES.FAILURE, loadMoreCandidatesOnFailure),

    takeLatest(searchConstants.APPLY_FILTERS.TRIGGER, applyFilters),
    takeLatest(searchConstants.APPLY_FILTERS.SUCCESS, applyFiltersOnSuccess),
    takeLatest(searchConstants.APPLY_FILTERS.FAILURE, applyFiltersOnFailure),
    // to use below pattern, 'connected-react-router' is required in dependencies.
    // takeLatest('@@router/LOCATION_CHANGE', handleLocationChange),
  ]);
}

